import { useMemo } from 'react';
import { getRestaurantId } from 'state/app';
import { getOrderCart } from 'state/orders';
import { useAppSelector } from 'state/store';

export const useLuncheonVoucherEligibilityRules = () => {
    const restaurantId = useAppSelector(getRestaurantId);
    const products = useAppSelector(getOrderCart(restaurantId));

    const isEveryProductEligible = useMemo(() => {
        return products.every((product) => product.isEligibleLuncheon);
    }, [products]);

    const cartContainsOnlyEligibleProducts = isEveryProductEligible;

    return {
        cartContainsOnlyEligibleProducts,
    };
};
